import React from 'react';
import { Modal } from 'antd';
import { 
  PhoneOutlined, MailOutlined, EnvironmentOutlined,
  FacebookOutlined, InstagramOutlined, WhatsAppOutlined,
  HeartOutlined, SearchOutlined
} from '@ant-design/icons';
import { FONT_COMBOS } from './TipografiasTab';

const PreviewMicrositio = ({ config, evento, visible, onClose, mini = false }) => {
  
  const fontCombo = FONT_COMBOS[config.tipografia_combo] || FONT_COMBOS.moderna;
  
  // Generar CSS dinámico basado en la configuración
  const generateStyles = () => `
    @import url('${fontCombo.googleUrl}');
    
    .preview-micrositio {
      --color-primary: ${config.color_primary};
      --color-secondary: ${config.color_secondary};
      --color-title: ${config.color_title};
      --color-subtitle: ${config.color_subtitle};
      --color-paragraph: ${config.color_paragraph};
      --color-icon: ${config.color_icon};
      --color-icon-hover: ${config.color_icon_hover};
      --color-cta-bg: ${config.color_cta_bg};
      --color-btn-primary: ${config.color_btn_primary};
      --color-btn-primary-hover: ${config.color_btn_primary_hover};
      --color-btn-secondary: ${config.color_btn_secondary};
      --color-btn-secondary-hover: ${config.color_btn_secondary_hover};
      --font-title: '${fontCombo.titulo}', serif;
      --font-body: '${fontCombo.cuerpo}', sans-serif;
      
      font-family: var(--font-body);
      background-color: #fff;
      min-height: ${mini ? '500px' : '100vh'};
      transform: ${mini ? 'scale(0.55)' : 'scale(1)'};
      transform-origin: top left;
      width: ${mini ? '182%' : '100%'};
    }
    
    .preview-micrositio h1, 
    .preview-micrositio h2, 
    .preview-micrositio h3 {
      font-family: var(--font-title);
      color: var(--color-title);
      margin: 0;
    }
    
    .preview-micrositio h4, 
    .preview-micrositio h5 {
      font-family: var(--font-title);
      color: var(--color-subtitle);
      margin: 0;
    }
    
    .preview-micrositio p {
      color: var(--color-paragraph);
      line-height: 1.6;
    }
    
    .preview-micrositio .btn-primary {
      background-color: var(--color-btn-primary);
      color: #fff;
      border: none;
      padding: 10px 24px;
      border-radius: 6px;
      cursor: pointer;
      font-weight: 500;
      transition: background-color 0.3s;
    }
    
    .preview-micrositio .btn-primary:hover {
      background-color: var(--color-btn-primary-hover);
    }
    
    .preview-micrositio .btn-secondary {
      background-color: var(--color-btn-secondary);
      color: #fff;
      border: none;
      padding: 10px 24px;
      border-radius: 6px;
      cursor: pointer;
      font-weight: 500;
      transition: background-color 0.3s;
    }
    
    .preview-micrositio .btn-secondary:hover {
      background-color: var(--color-btn-secondary-hover);
    }
    
    .preview-micrositio .icon {
      color: var(--color-icon);
      transition: color 0.3s;
    }
    
    .preview-micrositio .icon:hover {
      color: var(--color-icon-hover);
    }
    
    .preview-micrositio .cta-section {
      background-color: var(--color-cta-bg);
    }
  `;

  const menuItems = ['Inicio', 'Catálogo', 'Nosotros', 'Contacto', 'Eventos'];

  // Renderizar header según tipo de cabecera (CORREGIDO)
  const renderHeader = () => {
    switch (config.cabecera) {
      case 'cabecera-1': // Logo izquierda + menú centrado
        return (
          <header style={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: 'center', 
            padding: '15px 24px',
            borderBottom: '1px solid #eee'
          }}>
            <div style={{ 
              backgroundColor: '#ddd', 
              width: 100, 
              height: 50, 
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#666'
            }}>
              LOGO
            </div>
            <nav style={{ display: 'flex', gap: 24 }}>
              {menuItems.map(item => (
                <a key={item} href="#" style={{ color: 'var(--color-paragraph)', textDecoration: 'none', fontSize: 14 }}>
                  {item}
                </a>
              ))}
            </nav>
            <button className="btn-primary" style={{ padding: '8px 20px' }}>Acceder</button>
          </header>
        );
        
      case 'cabecera-2': // Logo centrado + menú integrado
        return (
          <header style={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: 'center', 
            padding: '15px 24px',
            borderBottom: '1px solid #eee'
          }}>
            <nav style={{ display: 'flex', gap: 20 }}>
              {menuItems.slice(0, 3).map(item => (
                <a key={item} href="#" style={{ color: 'var(--color-paragraph)', textDecoration: 'none', fontSize: 14 }}>
                  {item}
                </a>
              ))}
            </nav>
            <div style={{ 
              backgroundColor: '#ddd', 
              width: 100, 
              height: 50, 
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#666'
            }}>
              LOGO
            </div>
            <div style={{ display: 'flex', gap: 20, alignItems: 'center' }}>
              {menuItems.slice(3).map(item => (
                <a key={item} href="#" style={{ color: 'var(--color-paragraph)', textDecoration: 'none', fontSize: 14 }}>
                  {item}
                </a>
              ))}
              <button className="btn-primary" style={{ padding: '8px 20px' }}>Acceder</button>
            </div>
          </header>
        );
        
      case 'cabecera-3': // Logo centrado + menú debajo
        return (
          <header style={{ borderBottom: '1px solid #eee' }}>
            <div style={{ textAlign: 'center', padding: '20px 0' }}>
              <div style={{ 
                backgroundColor: '#ddd', 
                width: 120, 
                height: 60, 
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#666'
              }}>
                LOGO
              </div>
            </div>
            <nav style={{ 
              display: 'flex', 
              justifyContent: 'center', 
              gap: 32,
              padding: '12px 0',
              borderTop: '1px solid #eee'
            }}>
              {menuItems.map(item => (
                <a key={item} href="#" style={{ color: 'var(--color-paragraph)', textDecoration: 'none' }}>
                  {item}
                </a>
              ))}
              <button className="btn-primary" style={{ padding: '6px 16px', fontSize: 13 }}>
                Acceder
              </button>
            </nav>
          </header>
        );
        
      case 'cabecera-4': // Logo izquierda + menú debajo
      default:
        return (
          <header style={{ borderBottom: '1px solid #eee' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '15px 24px' }}>
              <div style={{ 
                backgroundColor: '#ddd', 
                width: 100, 
                height: 50, 
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#666'
              }}>
                LOGO
              </div>
              <button className="btn-primary" style={{ padding: '8px 20px' }}>Acceder</button>
            </div>
            <nav style={{ 
              display: 'flex', 
              gap: 24,
              padding: '10px 24px',
              backgroundColor: '#fafafa'
            }}>
              {menuItems.map(item => (
                <a key={item} href="#" style={{ color: 'var(--color-paragraph)', textDecoration: 'none', fontSize: 14 }}>
                  {item}
                </a>
              ))}
            </nav>
          </header>
        );
    }
  };

  // Renderizar grid de animales
  const renderCatalogo = () => {
    const columnas = parseInt(config.columnas_catalogo) || 4;
    const animalesDemo = Array(8).fill(null).map((_, i) => ({
      id: i + 1,
      nombre: `Toro ${i + 1}`,
      rp: `RP-${1000 + i}`,
      precio: 150000 + (i * 10000)
    }));
    
    const filtroSidebar = (
      <div style={{ 
        backgroundColor: '#f8f8f8', 
        padding: 16, 
        borderRadius: 8,
        width: 200,
        flexShrink: 0
      }}>
        <h4 style={{ marginBottom: 16 }}>Filtros</h4>
        <div style={{ marginBottom: 12 }}>
          <label style={{ fontSize: 12, color: '#666' }}>Categoría</label>
          <select style={{ width: '100%', padding: 8, marginTop: 4 }}>
            <option>Todas</option>
            <option>Toros</option>
            <option>Vaquillonas</option>
          </select>
        </div>
        <div style={{ marginBottom: 12 }}>
          <label style={{ fontSize: 12, color: '#666' }}>Cabaña</label>
          <select style={{ width: '100%', padding: 8, marginTop: 4 }}>
            <option>Todas</option>
            <option>Santa Irene</option>
            <option>Los Guasunchos</option>
          </select>
        </div>
        <div style={{ marginBottom: 12 }}>
          <label style={{ fontSize: 12, color: '#666' }}>Precio</label>
          <input type="range" style={{ width: '100%', marginTop: 4 }} />
        </div>
        <button className="btn-secondary" style={{ width: '100%', padding: '8px' }}>
          <SearchOutlined /> Buscar
        </button>
      </div>
    );
    
    const grid = (
      <div style={{ 
        display: 'grid', 
        gridTemplateColumns: `repeat(${columnas}, 1fr)`,
        gap: 16,
        flex: 1
      }}>
        {animalesDemo.map(animal => (
          <div key={animal.id} style={{ 
            border: '1px solid #eee', 
            borderRadius: 8,
            overflow: 'hidden',
            backgroundColor: '#fff'
          }}>
            <div style={{ 
              backgroundColor: '#e8e8e8', 
              height: 100,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#999'
            }}>
              Imagen
            </div>
            <div style={{ padding: 10 }}>
              <h4 style={{ fontSize: 13 }}>{animal.nombre}</h4>
              <p style={{ fontSize: 11, margin: '4px 0' }}>{animal.rp}</p>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 6 }}>
                <span style={{ fontWeight: 600, color: 'var(--color-primary)', fontSize: 12 }}>
                  ${animal.precio.toLocaleString()}
                </span>
                <HeartOutlined className="icon" style={{ cursor: 'pointer', fontSize: 14 }} />
              </div>
            </div>
          </div>
        ))}
      </div>
    );
    
    return (
      <section style={{ padding: 24 }}>
        <h2 style={{ marginBottom: 24, fontSize: mini ? 16 : 24 }}>Catálogo de Animales</h2>
        <div style={{ display: 'flex', gap: 24 }}>
          {config.filtro_posicion === 'izquierda' && filtroSidebar}
          {grid}
          {config.filtro_posicion === 'derecha' && filtroSidebar}
        </div>
      </section>
    );
  };

  // Renderizar footer (AHORA SIEMPRE VISIBLE)
  const renderFooter = () => {
    const columnas = parseInt(config.columnas_footer) || 3;
    
    return (
      <footer style={{ 
        backgroundColor: '#1a1a1a', 
        color: '#fff', 
        padding: '40px 24px 20px',
        marginTop: 40
      }}>
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: `repeat(${columnas}, 1fr)`,
          gap: 32,
          marginBottom: 24
        }}>
          {/* Columna 1: Logo */}
          <div>
            <div style={{ 
              backgroundColor: '#444', 
              width: 100, 
              height: 50, 
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginBottom: 16
            }}>
              LOGO
            </div>
            <p style={{ color: '#aaa', fontSize: 13 }}>
              {evento?.nombre || 'Remate Ganadero'}
            </p>
            <p style={{ color: '#888', fontSize: 12 }}>
              Productores ganaderos de excelencia
            </p>
          </div>
          
          {/* Columna 2: Enlaces */}
          <div>
            <h5 style={{ color: '#fff', marginBottom: 12, fontSize: 14 }}>Enlaces</h5>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              <li style={{ marginBottom: 8 }}>
                <a href="#" style={{ color: '#aaa', textDecoration: 'none', fontSize: 13 }}>Inicio</a>
              </li>
              <li style={{ marginBottom: 8 }}>
                <a href="#" style={{ color: '#aaa', textDecoration: 'none', fontSize: 13 }}>Catálogo</a>
              </li>
              <li style={{ marginBottom: 8 }}>
                <a href="#" style={{ color: '#aaa', textDecoration: 'none', fontSize: 13 }}>Nosotros</a>
              </li>
              <li style={{ marginBottom: 8 }}>
                <a href="#" style={{ color: '#aaa', textDecoration: 'none', fontSize: 13 }}>Contacto</a>
              </li>
            </ul>
          </div>
          
          {/* Columna 3: Contacto */}
          <div>
            <h5 style={{ color: '#fff', marginBottom: 12, fontSize: 14 }}>Contacto</h5>
            <p style={{ color: '#aaa', fontSize: 13, display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
              <PhoneOutlined style={{ color: 'var(--color-primary)' }} /> +54 351 123-4567
            </p>
            <p style={{ color: '#aaa', fontSize: 13, display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
              <MailOutlined style={{ color: 'var(--color-primary)' }} /> info@cabana.com
            </p>
            <p style={{ color: '#aaa', fontSize: 13, display: 'flex', alignItems: 'center', gap: 8 }}>
              <EnvironmentOutlined style={{ color: 'var(--color-primary)' }} /> Córdoba, Argentina
            </p>
          </div>
          
          {/* Columna 4: Redes (solo si footer tiene 4 columnas) */}
          {columnas >= 4 && (
            <div>
              <h5 style={{ color: '#fff', marginBottom: 12, fontSize: 14 }}>Síguenos</h5>
              <div style={{ display: 'flex', gap: 16 }}>
                <FacebookOutlined style={{ fontSize: 24, color: '#aaa', cursor: 'pointer' }} />
                <InstagramOutlined style={{ fontSize: 24, color: '#aaa', cursor: 'pointer' }} />
                <WhatsAppOutlined style={{ fontSize: 24, color: '#aaa', cursor: 'pointer' }} />
              </div>
              <p style={{ color: '#666', fontSize: 11, marginTop: 16 }}>
                Seguinos en redes para enterarte de las novedades
              </p>
            </div>
          )}
        </div>
        
        {/* Copyright */}
        <div style={{ 
          borderTop: '1px solid #333', 
          paddingTop: 16, 
          textAlign: 'center',
          color: '#666',
          fontSize: 11
        }}>
          © 2026 {evento?.nombre || 'Cabaña Demo'}. Todos los derechos reservados. | Powered by Puja - Gestión de Cabañas
        </div>
      </footer>
    );
  };

  const previewContent = (
    <div className="preview-micrositio">
      <style>{generateStyles()}</style>
      {renderHeader()}
      
      {/* Hero section */}
      <section className="cta-section" style={{ padding: mini ? '30px 24px' : '60px 24px', textAlign: 'center' }}>
        <h1 style={{ fontSize: mini ? 18 : 36, marginBottom: 16 }}>
          {evento?.nombre || 'Bienvenidos a Nuestro Evento'}
        </h1>
        <p style={{ maxWidth: 600, margin: '0 auto 24px', fontSize: mini ? 12 : 16 }}>
          Descubra nuestra selección de animales de alta genética. 
          Más de 50 años de experiencia en producción ganadera.
        </p>
        <div style={{ display: 'flex', gap: 16, justifyContent: 'center' }}>
          <button className="btn-primary">Ver Catálogo</button>
          <button className="btn-secondary">Contactar</button>
        </div>
      </section>
      
      {renderCatalogo()}
      {renderFooter()}
    </div>
  );

  if (mini) {
    return (
      <div style={{ overflow: 'hidden', height: 500 }}>
        {previewContent}
      </div>
    );
  }

  return (
    <Modal
      title={`Vista Previa - ${evento?.nombre || 'Micrositio'}`}
      open={visible}
      onCancel={onClose}
      width="95%"
      style={{ top: 20 }}
      footer={null}
      styles={{ body: { padding: 0, maxHeight: '85vh', overflow: 'auto' } }}
    >
      {previewContent}
    </Modal>
  );
};

export default PreviewMicrositio;
